import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe} from '@angular/common';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { MenuFuncionService, TipoMaterialService, MaterialesService, ComunidadService, PedidoService, ProveedorService } from '../../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, Pedido, SearchTipoMaterialRequest, TipoMaterialDto, PedidoDto, Comunidad, SearchComunidadRequest,
  Proveedor, SearchProveedorRequest, PedidoRemito, PedidoRemitoDetalle, MaterialDto, SearchMaterialRequest, SearchPedidoItemsPendientesEntregaRequestDto
  } from '../../../../../src/app/shared/model';

@Component({
  selector: 'app-recepcion-pedido',
  templateUrl: './recepcion-pedido.component.html',
  styleUrls: ['./recepcion-pedido.component.scss']
})

export class RecepcionPedidoComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  itemList: PedidoRemitoDetalle[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isTipoMaterialSearching: boolean = false;
  isSaving: boolean = false;
  isTipoSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isMaterialAutoSearching: boolean = false;
  isProveedorSearching: boolean = false;

  hasPermission: boolean = false;
  verSoloActivos: boolean = true;

  filteredProveedorList: Proveedor[];
  filteredMaterialList: MaterialDto[] = [];
  tipoMaterialList: TipoMaterialDto[] = [];

  searchForm: FormGroup;
  remitoForm: FormGroup;
  total: number = 0;

  isFileAttaching: boolean = false;

  item: PedidoDto;

  comunidadList: Comunidad[] = [];
  msgError: string = "";

  public query: Query;
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;
  public gridPageSettings: GridPageSettings;

  remitoAdjuntoBase64: string | ArrayBuffer | null;
  remitoAdjuntoExtension: string = "";
  comprobanteFile: any;
  selectedFile: any;

  constructor(
    public sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private tipoMaterialService: TipoMaterialService,
    private materialService: MaterialesService,
    private service: PedidoService,
    private datePipe: DatePipe,
    private comunidadService: ComunidadService,
    private proveedorService: ProveedorService
  ) {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.buildForm();
    this.buildRemitoForm();
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.RECEPCION_PEDIDO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.hasPermission = true;
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.getTipoMaterial();
    this.getComunidades();

    this.getMaterialesAutocomplete();
    this.getAutocompleteProveedor();
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  displayMaterial(item: MaterialDto): string {
    return item && item?.Nombre ? item.Nombre : '';
  }

  isProcessing() {
    return (this.isSearching || this.isSaving);
  }

  canView() {
    return this.hasPermission &&
      this.remitoForm?.get("Proveedor")?.value?.Id > 0 &&
      this.remitoForm?.get("ComunidadDestinoId")?.value > 0;
  }

//#region forms

  buildRemitoForm() {
    this.remitoForm = this.formBuilder.group({
      'Codigo': [null],
      'ComunidadDestinoId': [null, Validators.required],
      'Proveedor': [null],
      'FechaEntrega': [new Date(), Validators.required]
    });
  }

  buildForm() {
    // const today = new Date();
    // const monday = this.getMondayOfWeek(today);
    // const saturday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 5);

    this.searchForm = this.formBuilder.group({
      'PedidoId': [null],
      'FechaEntregaPlanificadaDesde': [null],
      'FechaEntregaPlanificadaHasta': [null],
      'TipoMaterialId': [null],
      'Material': [null]
    });
  }

  getMondayOfWeek(date: Date): Date {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Calcula el lunes de la semana actual
    return new Date(date.setDate(diff));
  }

  onDetalleRemitoChange(rowIndex: number, pedidoItemId: number, event: any) {

    if (rowIndex >= 0) {
      var controlName = event?.target?.name;
      var controlValue = event?.target?.value;

      var index = this.itemList.indexOf(this.itemList.filter(f => f.PedidoItemId == pedidoItemId)[0]);

      if (index >= 0) {
        switch (controlName) {
          case "Cantidad":
            this.itemList[index].Cantidad = Number(controlValue);
            break;
          // case "Observacion":
          //   this.itemList[index].Observacion = controlValue;
          //   break;
        }
      }

      // this.grid.refresh();
    }
  }

//#endregion

//#region getters

  getComunidades() {
    var loggedUser = this.sharedFunctions.getLoggedUser();
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, (loggedUser?.PersonaId ? loggedUser?.PersonaId : null), null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null) {
        this.comunidadList = data?.result;
        if(data.result.length == 1)
        {
          this.remitoForm.controls['ComunidadDestinoId'].setValue(data.result[0].Id);

          if (this.remitoForm.value.ComunidadDestinoId != null && this.remitoForm.value.ComunidadDestinoId > 0)
            this.remitoForm.get('ComunidadDestinoId')?.setValue(this.remitoForm.value.ComunidadDestinoId);
        }
      }
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  searchItemsPendientesEntrega() {
    if (this.remitoForm.get("ComunidadDestinoId")?.value > 0 && this.remitoForm.get("Proveedor")?.value?.Id) {
      var r = new SearchPedidoItemsPendientesEntregaRequestDto(
        null,
        null,
        true,
        "FechaEntregaPlanificada",
        this.searchForm.get("TipoMaterialId")?.value,
        this.searchForm.get("PedidoId")?.value,
        this.remitoForm.get("ComunidadDestinoId")?.value,
        this.remitoForm.get("Proveedor")?.value?.Id,
        this.searchForm.get("Material")?.value?.Id,
        this.searchForm.get("FechaEntregaPlanificadaDesde")?.value,
        this.searchForm.get("FechaEntregaPlanificadaHasta")?.value
      );

      this.isSearching = true;
      this.service.searchItemsPendientesEntrega(r).subscribe(data => {
        this.isSearching = false;
        this.itemList = data?.result?.map(s => new PedidoRemitoDetalle(0, null, 0, s.Id, s.PedidoId, s.ProveedorId,
          s.ProveedorNombre, s.ComunidadDestinoNombre, s.FechaEntregaPlanificada, s.MaterialId, s.MaterialNombre,
          s.MaterialUnidadMedida, s.Detalle, s.Cantidad, 0, ''));
      },
      (err: HttpErrorResponse) => {
        this.isSearching = false;
        this.sharedFunctions.handleError(err, true);
      });
    }
  }

  getTipoMaterial() {
    var r = new SearchTipoMaterialRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoMaterialSearching = true;

    this.tipoMaterialService.search(r).subscribe(data => {
      this.isTipoMaterialSearching = false;
      this.tipoMaterialList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMaterialSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMaterialesAutocomplete() {
    this.searchForm.get('Material')?.valueChanges
    .pipe(
      filter(res => {
        if (res && res !== null && res.length >= 3) {
          this.isMaterialAutoSearching = true;
          return true;
        }
        return false;
      }),
      distinctUntilChanged(),
      debounceTime(3000),
      tap(() => {
        this.filteredMaterialList = [];
        this.isMaterialAutoSearching = true;
      }),
      switchMap(value => this.materialService.search(new SearchMaterialRequest(null, null, null, null, value,null,!isNumber(parseInt(value)) ? value : null, true))
        .pipe(
          finalize(() => {
            this.isMaterialAutoSearching = false;
          }),
        )
      )
    )
    .subscribe((data: any) => {
      this.isMaterialAutoSearching = false;
      if (data != null && data.result != null){
        this.filteredMaterialList = data.result;
      }
      else
        this.filteredMaterialList = [];
    });
  }

  getAutocompleteProveedor() {
    this.remitoForm.get("Proveedor")?.valueChanges
    .pipe(
      filter(res => {
        if (res && res !== null && res.length >= 3) {
          this.isProveedorSearching = true;
          return true;
        }
        return false;
      }),
      distinctUntilChanged(),
      debounceTime(3000),
      tap(() => {
          this.filteredProveedorList = [];
      }),
      switchMap(value => this.proveedorService.search(new SearchProveedorRequest(50, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
        .pipe(
          finalize(() => {
            this.isProveedorSearching = false;
          }),
        )
      )
    )
    .subscribe((data: any) => {
      this.isProveedorSearching = false;
      if (data != null && data.result != null) {
        this.filteredProveedorList = data.result;
      }
      else
        this.filteredProveedorList = [];
    });
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
        this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

//#endregion

//#region grid

  onGridActionFailure(event: any): void {
    // this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda errror", "Error");
    // console.log(event)
  }

//#endregion

//#region actions

  onGuardar() {
    if (!this.remitoForm.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var index = this.remitoAdjuntoBase64?.toString()?.indexOf(",");
    var r = new PedidoRemito(null, null, null,null,null,null,null,[]);
    r =
    {
      ...this.remitoForm.value,
      ...{
        ComunidadDestinoId: this.remitoForm?.get("ComunidadDestinoId")?.value,
        ProveedorId: this.remitoForm?.get("Proveedor")?.value?.Id,
        RemitoDetalle: this.itemList?.filter(f => f.Cantidad > 0),
        RemitoBase64: (index != null && index >= 0 ? this.remitoAdjuntoBase64?.toString()?.substring(index + 1) : null),
        RemitoExtension: this.remitoAdjuntoExtension,
      }
    };

    this.isSaving = true;
    this.service.saveRemito(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id !== null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  add() {
    this.router.navigate(['pedido-edit', 0]);
  }

  edit(item: Pedido) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['pedido-edit', item.Id]);
  }

  onCancel() {
    this.location.back();
  }

  selectFile(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.comprobanteFile = event.target.files;
    }
    let files = [].slice.call(event.target.files);
    this.selectedFile = files.map(f => f.name).join(', ');
    this.convertFileToBase64(event);
  }

  convertFileToBase64(event) {
    this.remitoAdjuntoBase64 = null;
    const file = event.target.files[0];
    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.remitoAdjuntoBase64 = reader.result;
      };
      reader.onloadend = () => {
        this.remitoAdjuntoBase64 = reader.result;
        this.remitoAdjuntoExtension = (file?.name?.split('.')?.pop() ?? "");
      };
    }
  }

  deleteFile() {
    this.remitoAdjuntoBase64 = null;
    this.remitoAdjuntoExtension = '';
  }

  getErrorCodigo() {
    var v = this.remitoForm.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorProveedor() {
    return this.remitoForm.get('Proveedor')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorComunidadDestino() {
    return this.remitoForm.get('ComunidadDestinoId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorFechaEntrega() {
    return this.remitoForm.get('FechaEntrega')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

//#endregion
}
